import script from "./ModalWarningMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalWarningMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ModalWarningMessage.vue?vue&type=style&index=0&id=6b0d6498&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b0d6498"]])

export default __exports__